"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var parser_1 = require("./parser");
var emitter_1 = require("./emitter");
var canonicalizer_1 = require("./canonicalizer");
function canonicalizeLocaleList(locales) {
    if (locales === undefined) {
        return [];
    }
    var seen = [];
    if (typeof locales === 'string') {
        locales = [locales];
    }
    for (var _i = 0, locales_1 = locales; _i < locales_1.length; _i++) {
        var locale = locales_1[_i];
        var canonicalizedTag = emitter_1.emitUnicodeLocaleId(canonicalizer_1.canonicalizeUnicodeLocaleId(parser_1.parseUnicodeLocaleId(locale)));
        if (seen.indexOf(canonicalizedTag) < 0) {
            seen.push(canonicalizedTag);
        }
    }
    return seen;
}
function getCanonicalLocales(locales) {
    return canonicalizeLocaleList(locales);
}
exports.getCanonicalLocales = getCanonicalLocales;
var parser_2 = require("./parser");
exports.parseUnicodeLocaleId = parser_2.parseUnicodeLocaleId;
exports.parseUnicodeLanguageId = parser_2.parseUnicodeLanguageId;
exports.isStructurallyValidLanguageTag = parser_2.isStructurallyValidLanguageTag;
exports.isUnicodeRegionSubtag = parser_2.isUnicodeRegionSubtag;
exports.isUnicodeScriptSubtag = parser_2.isUnicodeScriptSubtag;
exports.isUnicodeLanguageSubtag = parser_2.isUnicodeLanguageSubtag;
__export(require("./emitter"));
//# sourceMappingURL=index.js.map